import { useState, useEffect } from "react";

/**
 * Custom hook to detect if the current device is mobile
 * @param {number} breakpoint - The width threshold in pixels to consider a device as mobile (default: 768)
 * @returns {boolean} - Returns true if device is mobile, false otherwise
 */
const useIsMobile = (breakpoint = 780) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if window is defined (to avoid SSR issues)
    if (typeof window === "undefined") {
      return;
    }

    // Function to check if device is mobile based on screen width
    const checkIsMobile = () => {
      const clientWidth = document.documentElement.clientWidth;

      setIsMobile(clientWidth < breakpoint);
      // setIsMobile(window.innerWidth < breakpoint);
    };

    // Initial check
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIsMobile);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
